import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { ColaboradorCadastro } from 'src/app/models/colaborador-cadastro';
import { ColaboradorCadastroArquivo } from 'src/app/models/colaborador-cadastro-arquivo';
import { OpcaoCadastroArquivo } from 'src/app/models/opcao-cadastro-arquivo';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import * as jexcel from 'jexcel';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Auth } from 'src/app/models/auth';
import { runInThisContext } from 'vm';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { FormFields } from 'src/app/models/form-field';
import { CollaboratorType } from 'src/app/models/collaborator-type';
import { CollaboratorAddress } from 'src/app/models/colaborador';
import { CreateCollaborator, CreateCollaboratorBatch } from 'src/app/models/colaborador-batch';
import { Subscription, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-colaborador-create-arquivo',
  templateUrl: './colaborador-create-arquivo.component.html',
  styleUrls: ['./colaborador-create-arquivo.component.css']
})
export class ColaboradorCreateArquivoComponent implements OnInit, AfterViewInit {
  // variáveis tabela
  public table: any;
  public tableHTML = 'tabela';

  // helper para tabela
  private headers: any[] = [];

  // variáveis
  public opcoesArquivo: OpcaoCadastroArquivo[] = [];
  public opcaoArquivoSelecionado: OpcaoCadastroArquivo;

  public colaboradores: ColaboradorCadastro[] = [];

  public currentUser: Auth;
  public file: string;
  public download: SafeUrl;
  public tipoColaborador: number;
  campoFormulario: FormFields[];
  public collaboratorType: CollaboratorType[];
  public index = [];
  public sub: Subscription;

  public error = false;

  public accept = ['csv'];

  constructor(private alertService: NewAlertService, private authenticationService: AuthenticationService,
    private router: Router, private route: ActivatedRoute, private sanitizer: DomSanitizer,
    private arquivoService: ArquivoService, private ColaboradorService: ColaboradorService) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    // carregar opções
    this.loadHeaders();

    this.collaboratorType = JSON.parse(localStorage.getItem('collaboratorType'));
    this.tipoColaborador = this.collaboratorType[0].collaboratorTypeId;
    this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;

    this.campoFormulario.forEach( obj => {
      this.index[obj?.formFieldId-1] = this.headers?.find( x => x?.title.replace(/\*/g,"") == obj?.formFieldDescription.replace(/\*/g,"").normalize('NFD').replace(/[\u0300-\u036f]/g, ""))?.id+1;
    });

    this.loadServices();


    this.tipocolaborador(this.tipoColaborador);
  }

  loadServices() {
    this.arquivoService.getOpcoesArquivo("colaborador").subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.opcoesArquivo = response.result;
          this.setOpcaoArquivo(this.opcoesArquivo[0]);
          this.requiredFile(this.opcoesArquivo[0]);
        } else {
          this.alertService.error(response.message);
        }
      }, error => { this.alertService.error(error.error); }
    );
  }


  setOpcaoArquivo(item: OpcaoCadastroArquivo) {
    this.opcaoArquivoSelecionado = item;
  }

  requiredFile(item){  
    if(item?.Id == 3){
      let campos = item.urlArquivoExemplo.replace(/\*/g,"").split(";");

      item.urlArquivoExemplo = '';
      this.campoFormulario.forEach( obj => {
        let i = this.index[obj.formFieldId-1];
        campos[i-1] = obj.isStandard ? this.headers[i-1]?.title+"*" : this.headers[i-1]?.title ;
        this.headers[i-1].title = obj.isStandard ? this.headers[i-1]?.title.replace(/\*/g,"")+"*" : this.headers[i-1]?.title.replace(/\*/g,"") ;
      });
      for(let i=0;i<campos.length;i++){
        campos[i] = this.headers[i]?.title;
        if((this.tipoColaborador == 1 || this.tipoColaborador == 2) && (i>=12 && i<19)){
          campos[i] = this.headers[i]?.title+'*';
        }
        item.urlArquivoExemplo += i<campos.length-1 ? campos[i]+';' : campos[i];
      };
      this.download = this.downloadFile(item.urlArquivoExemplo);
    }
    
    this.setTableHeader();
  }

  ngAfterViewInit() {
    // this.table = this.loadjExcel(6, 10, this.tableHTML);
  }

  // construtor da tabel
  loadjExcel(numberOfCols: number, numberOfRows: number, tableHTML: string) {
    const collums: any = [];
    this.headers.forEach(element => {
      collums.push(element);
    });
    return jexcel(document.getElementById(tableHTML), {
      data: [[]],
      columns: collums,
      columnDrag: true,
      minDimensions: [numberOfCols, numberOfRows],
      defaultColWidth: 180,
      columnSorting: false,
      updateTable(instance, cell, col, row, val, label, cellName) {
        val.replace('-', '').replace('.', '');
        if (col === 0 && val.length < 11 && val.length > 0) {
          while (val.length < 11) {
            val = '0' + val;
          }
          val = val.slice(0, 3) + '.' + val.slice(3, 6) + '.' + val.slice(6, 9) + '-' + val.slice(9, 11);
          cell.innerHTML = val;
        }
      },
      //#region Tradução
      text: {
        noRecordsFound: 'Nenhum registro encontrado',
        showingPage: 'Mostrando página {0} de {1} entradas',
        show: 'Show',
        entries: 'entradas',
        insertANewColumnBefore: 'Inserir uma nova coluna antes de',
        insertANewColumnAfter: 'Inserir uma nova coluna depois de',
        deleteSelectedColumns: 'Excluir colunas selecionadas',
        renameThisColumn: 'Renomear esta coluna',
        orderAscending: 'ordem ascendente',
        orderDescending: 'Order decrescente',
        insertANewRowBefore: 'Inserir uma nova linha antes de',
        insertANewRowAfter: 'Inserir uma nova linha depois de',
        deleteSelectedRows: 'Excluir linhas selecionadas',
        editComments: 'Editar comentários',
        addComments: 'Adicionar comentários',
        comments: 'Comentários',
        clearComments: 'Limpar comentários',
        copy: 'Copiar ...',
        paste: 'Colar ...',
        saveAs: 'Salvar como ...',
        about: 'About',
        areYouSureToDeleteTheSelectedRows: 'Tem certeza de excluir as linhas selecionadas?',
        areYouSureToDeleteTheSelectedColumns: 'Tem certeza de excluir as colunas selecionadas?',
        // tslint:disable-next-line: max-line-length
        thisActionWillDestroyAnyExistingMergedCellsAreYouSure: 'Esta ação irá destruir todas as células mescladas existentes. Você tem certeza?',
        thisActionWillClearYourSearchResultsAreYouSure: 'Esta ação limpará seus resultados de pesquisa. Você tem certeza?',
        thereIsAConflictWithAnotherMergedCell: 'Há um conflito com outra célula mesclada',
        invalidMergeProperties: 'Propriedades mescladas inválidas',
        cellAlreadyMerged: 'Célula já mesclado',
        noCellsSelected: 'Nenhuma célula selecionada',
        update: 'Atualizar',
        reset: 'Limpar',
        done: 'Pronto'

      }
      //#endregion
    });
  }

  loadHeaders() {
    let index = 0;
    this.headers.push({
      title: 'CPF',
      colspan: '1',
      type: 'text',
      mask: '000.000.000-00',
      id: index
    }); index++;

    this.headers.push({
      title: 'Nome*',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    // this.headers.push({
    //   title: 'Sobrenome*',
    //   colspan: '1',
    //   type: 'text',
    //   id: index
    // }); 
    // index++;

    this.headers.push({
      title: 'Data de Nascimento',
      colspan: '1',
      type: 'text',
      mask: '00/00/0000',
      /*  options : {
         months: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
         weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
         weekdays_short: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']
     }, */
      id: index
    }); index++;

    this.headers.push({
      title: 'Telefone',
      colspan: '1',
      type: 'number',
      mask: '(00) 00000-0000',
      id: index
    }); index++;

    this.headers.push({
      title: 'E-mail',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'Sexo',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'Matricula',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'Centro de custo',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'Departamento',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'Unidade',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'Nome da Mae',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'Nome do Pai',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'Endereco',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'Numero',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'Complemento',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'CEP',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'Bairro',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'Cidade',
      colspan: '1',
      type: 'text',
      id: index
    }); index++;

    this.headers.push({
      title: 'Estado(UF)',
      colspan: '1',
      type: 'text',
      id: index
    });

    this.table = this.loadjExcel(19, 10, this.tableHTML);
  }

  continuarArquivo() {
    const cedenteGuid = this.currentUser.token.assignorGuid;
    const gestorGuid = this.currentUser.token.userReferenceId;
    const file = this.file;
    const tipoColab = this.collaboratorType.find(x => x.collaboratorTypeId == this.tipoColaborador);

    if (!file) {
      this.alertService.error('Todos os campos estão vazios');
      return;
    }

    const Cadastros = new CreateCollaboratorBatch(null, file, tipoColab.collaboratorTypeId);

    this.ColaboradorService.createCollaboratorBatch(Cadastros, gestorGuid, cedenteGuid).subscribe(res => {
      if (res.status === ApiError.Sucesso) {
        this.alertService.success(res.message);
        this.router.navigate([`arquivo-confimar/${res.result}`], { relativeTo: this.route.parent });
      } else {
        this.alertService.error(res.message);
      }
    })

  }

  continuarTabela() {
    const cedenteGuid = this.currentUser.token.assignorGuid;
    const gestorGuid = this.currentUser.token.userReferenceId;
    const items = this.getItems(this.table.getJson());
    const tipoColab = this.collaboratorType.find(x => x.collaboratorTypeId == this.tipoColaborador);

    if (this.error) {
      return;
    }

    if (items.length === 0) {
      this.alertService.error('Todos os campos estão vazios');
      return;
    }

    const Cadastros = new CreateCollaboratorBatch(items, null, tipoColab.collaboratorTypeId);

    this.ColaboradorService.createCollaboratorBatch(Cadastros, gestorGuid, cedenteGuid).subscribe(res => {
      if (res.status === ApiError.Sucesso) {
        this.alertService.success(res.message);
        this.router.navigate([`arquivo-confimar/${res.result}`], { relativeTo: this.route.parent });
      } else {
        this.alertService.error(res.message);
      }
    })

  }

  getItems(json: any): CreateCollaborator[] {

    const items: CreateCollaborator[] = [];

    this.error = false;

    json.forEach((element, index) => {

      if (this.validaCampo(0) && element['0'] === '' && !this.isEmpty(element)) {
        this.alertService.error('CPF obrigatório. Linha ' + (index + 1));
        this.error = true;
      } else if (element['1'] === '' && !this.isEmpty(element)) {
        this.alertService.error('Nome obrigatório. Linha ' + (index + 1));
        this.error = true;
      // } else if (element['2'] === '' && !this.isEmpty(element)) {
      //   this.alertService.error('Sobrenome obrigatório. Linha ' + (index + 1));
      //   this.error = true;
      } else if (this.validaCampo(2) && !Number(element['2'].replace(/[^\d]+/g,'')) && !this.isEmpty(element)) {
        this.alertService.error('Data de nascimento obrigatório. Linha ' + (index + 1));
        this.error = true;
      } else if (this.validaCampo(2) && !this.isDate(element['2']) && !this.isEmpty(element)) {
        this.alertService.error('Data de nascimento inválida. Linha ' + (index + 1));
        this.error = true;
      } else if (this.validaCampo(3) && !Number(element['3'].replace(/[^\d]+/g,'')) && !this.isEmpty(element)) {
        this.alertService.error('Telefone obrigatório. Linha ' + (index + 1));
        this.error = true;
      } else if (!this.error && !this.isEmpty(element)) {

        const cpf = element['0'].replace(/\D/g, '');
        const telefone = element['3'].replace(/[^\d]+/g,'');
        const dataNascimento = this.formatDate(element['2']);
        const sexo = element['5'] != "" && (element['5'].toUpperCase() === 'M' || element['5'].toUpperCase() === 'F') ? element['5'] : "I";
        const email = element['4'] != "" ? element['4'] : null;

        const item = new CreateCollaborator(
          email, //Email
          element['1'], //Nome
          null, // element['2'], //Sobrenome
          cpf,          //CPF
          dataNascimento, //DataNascimento
          sexo, //Sexo
          element['6'], //Matricula
          element['10'],//NomeMae
          element['11'],//NomePai
          telefone, //Telefone
          element['7'], //CentroCusto
          element['9'],//Unidade
          element['8'], //Departamento
        );

        item.endereco = new CollaboratorAddress();
        item.endereco.address = element['12'],// address
          item.endereco.number = element['13'],// number
          item.endereco.complement = element['14'],// complement
          item.endereco.cep = element['15'],// cep
          item.endereco.neighborhood = element['16'],// neighborhood
          item.endereco.city = element['17'],// city
          item.endereco.uf = element['18']// uf

        items.push(item);

      }
    });

    return items;
  }

  validaCampo(i){
    return this.campoFormulario.some(x => x.formFieldId == (this.index.indexOf(i+1)+1) && x.isStandard);
  }

  isEmpty(elem: any) {
    return elem['0'] === '' && elem['1'] === '' && elem['2'] === '' && elem['3'] === '' &&
      elem['4'] === '' && elem['5'] === '' && elem['6'] === '' && elem['7'] === '' && elem['8'] === '' &&
      elem['9'] === '' && elem['10'] === '' && elem['11'] === '' && elem['12'] === '';
  }

  isDate(data: any){
    var RegExPattern = /^((((0?[1-9]|[12]\d|3[01])[\.\-\/](0?[13578]|1[02])      [\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[\.\-\/](0?[13456789]|1[012])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|(29[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;

    if (!((data.match(RegExPattern)) && (data!=''))) {
      return false
    } else {
      return true
    }
  }

  formatDate(date: string) {
    const dateArray = date.split('/');
    if (!dateArray || dateArray.length !== 3 || dateArray.some(x => !Number(x))) {
      return null;
    }
    return new Date(`${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`);
  }

  setFile(file: any): void {
    /* console.log(file) */
    this.file = file;
    if (!file) {
      this.alertService.error('Formato de arquivo não suportado!');
      this.alertService.error('Formatos aceitos: CSV');
    }
  }

  downloadFile(data: string) {
    const blob = new Blob([data], { type: 'text/csv' });
    return this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(blob));
  }

  tipocolaborador(v: number, toggle: boolean = false){
    if(v == 1)
    {
      this.tipoColaborador = 1;
      this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
    }
    if(v == 2){
      this.tipoColaborador = 2;
      this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
    }
    if(v == 3){
      this.tipoColaborador = 3;
      this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
    }
    if(v == 4){
      this.tipoColaborador = 4;
      this.campoFormulario = this.collaboratorType.find(x=>x.collaboratorTypeId == this.tipoColaborador).formFields;
    }
    
    this.requiredFile(this.opcaoArquivoSelecionado);
  }

  setTableHeader() {  
    this.campoFormulario.forEach( obj => {
      let i = this.index[obj.formFieldId-1];
      document.getElementsByTagName("table")[0].rows[0].cells[i].innerHTML = obj.isStandard ? this.headers[i-1]?.title+"*" : this.headers[i-1]?.title ;
    });
  }
}
